import { format, isValid, parse } from 'date-fns';

/**
 * Parse a `YYYY-MM-DD` calendar string into a Date at local midnight. Empty
 * or invalid input yields `null`. Used at the boundary between form fields
 * (which carry ISO strings to match Postgres DATE / TIMESTAMPTZ conventions)
 * and `<DatePicker>` (which speaks `Date`).
 */
export function parseIsoDate(value: string | null | undefined): Date | null {
  if (!value) return null;
  const trimmed = value.slice(0, 10);
  const parsed = parse(trimmed, 'yyyy-MM-dd', new Date());
  return isValid(parsed) ? parsed : null;
}

/**
 * Format a Date as `YYYY-MM-DD` in local time. The backend's TIMESTAMPTZ
 * columns interpret bare YYYY-MM-DD as midnight UTC, so callers carrying
 * timestamps should preserve the original full ISO string elsewhere.
 */
export function formatIsoDate(value: Date | null | undefined): string {
  if (!value || !isValid(value)) return '';
  return format(value, 'yyyy-MM-dd');
}
